/*
  ToeGrips A/B variant 4 - two-step breed + weight size finder.

  Isolation notes (variant 4 must coexist with `ab-featured-product.liquid` on the
  same page). The control section's script (`custom-npa-size-recommendation-with-weights.js`)
  queries the whole document with no scoping - `document.getElementById('npa20221005-textfield')`,
  `document.querySelector('.ab-atc')`, `.npa-2022-tab-content1`, `.weight-subtext`, etc.
  So this variant:
    1. runs inside an IIFE, declaring no globals at all;
    2. uses a private `tg4-` prefix for every id/class the control script looks for;
    3. scopes every lookup to its own section element.
  The result is that neither script can see the other's DOM.
*/
(function () {
  'use strict';

  var SECTION_CLASS = 'ab-featured-product-section-4';
  var section = document.querySelector('.' + SECTION_CLASS);
  if (!section) return;

  /* Variant id, swatch colour and long-form label per ToeGrips size.
     Ids match the control script's `sizeids` map. */
  var SIZES = {
    XS:   { id: '37540578002', color: 'YELLOW', label: 'Extra Small' },
    S:    { id: '37843250002', color: 'RED',    label: 'Small' },
    M:    { id: '37843200658', color: 'BLUE',   label: 'Medium' },
    L:    { id: '37843255122', color: 'GREEN',  label: 'Large' },
    XL:   { id: '37844540818', color: 'PURPLE', label: 'Extra Large' },
    XXL:  { id: '37844543826', color: 'ORANGE', label: 'XX-Large' },
    XXXL: { id: '37844544466', color: 'NAVY',   label: 'XXX-Large' }
  };

  var DISCOUNT_CODE = 'TRYTODAY';
  var MIN_QUERY_LENGTH = 3;

  var ATC_LABEL_NO_BREED  = 'SELECT BREED TO BEGIN';
  var ATC_LABEL_NO_WEIGHT = 'SELECT WEIGHT RANGE';
  var ATC_LABEL_READY     = 'ADD TO CART';

  function $(selector) {
    return section.querySelector(selector);
  }

  var breedInput   = $('#tg4-breed-input');
  var suggestions  = $('#tg4-suggestions');
  var step2        = $('#tg4-step-2');
  var weightGrid   = $('#tg4-weight-grid');
  var result       = $('#tg4-result');
  var resultCopy   = $('#tg4-result-copy');
  var sizeBadge    = $('#tg4-size-badge');
  var atcButton    = $('#tg4-atc');
  var breedField   = $('#tg4-breed-property');
  var weightField  = $('#tg4-weight-property');

  /* Optional "choose your size directly" chart panel - only present when the
     section setting is enabled. */
  var chartPanel   = $('#tg4-chart-panel');
  var finderPanel  = $('#tg4-finder-panel');

  if (!breedInput || !suggestions || !weightGrid) return;

  /* Breed data. The section re-ids its own copy of the shared `NPAjson` blob to
     `NPAjson-4` during parse, so the control section keeps sole ownership of the
     original id. Fall back to the shared blob if that rename ever stops happening. */
  var breeds = (function () {
    var node = $('#NPAjson-4') || $('#NPAjson') || document.getElementById('NPAjson');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return [];
    }
  })();

  var selectedBreed = null;
  var highlighted = -1;

  /* ---------------------------------------------------------------- helpers */

  function show(el) {
    if (el) el.hidden = false;
  }

  function hide(el) {
    if (el) el.hidden = true;
  }

  /* A breed record stores up to seven [size, weightRange] pairs as size1..size7. */
  function weightRangesFor(breed) {
    var ranges = [];
    for (var i = 1; i <= 7; i++) {
      var pair = breed['size' + i];
      if (pair) ranges.push({ size: pair[0], range: pair[1] });
    }
    return ranges;
  }

  function displayBreed(name) {
    return name === "I don't know" ? 'dog' : name;
  }

  /* --------------------------------------------------------- add-to-cart cta */

  function setAtc(state, sizeKey) {
    if (!atcButton) return;

    if (state === 'ready') {
      var size = SIZES[sizeKey];
      atcButton.setAttribute(
        'href',
        '/cart/' + size.id + ':1?storefront=true&discount=' + DISCOUNT_CODE
      );
      atcButton.setAttribute('varid', size.id);
      atcButton.textContent = ATC_LABEL_READY;
      atcButton.classList.remove('disabled');
      return;
    }

    atcButton.setAttribute('href', '');
    atcButton.setAttribute('varid', '');
    atcButton.textContent = state === 'no-weight' ? ATC_LABEL_NO_WEIGHT : ATC_LABEL_NO_BREED;
    atcButton.classList.add('disabled');
  }

  /* ------------------------------------------------------------ step 2 / ui */

  function clearResult() {
    hide(result);
    if (resultCopy) resultCopy.innerHTML = '';
    if (weightField) weightField.value = '';
  }

  function resetToStep1() {
    selectedBreed = null;
    hide(step2);
    weightGrid.innerHTML = '';
    clearResult();
    if (breedField) breedField.value = '';
    setAtc('no-breed');
  }

  function renderResult(sizeKey, breedName) {
    var size = SIZES[sizeKey];
    if (!size || !result) return;

    if (sizeBadge) {
      sizeBadge.setAttribute('data-size', sizeKey);
      var sizeText = sizeBadge.querySelector('.tg4-size-badge__size');
      var colorText = sizeBadge.querySelector('.tg4-size-badge__color');
      if (sizeText) sizeText.textContent = sizeKey;
      if (colorText) colorText.textContent = size.color;
    }

    if (resultCopy) {
      resultCopy.innerHTML = '';
      resultCopy.appendChild(document.createTextNode('We recommend size '));
      var strong = document.createElement('strong');
      strong.textContent = size.label;
      resultCopy.appendChild(strong);
      resultCopy.appendChild(
        document.createTextNode(
          ' for your ' + displayBreed(breedName) + ' based on their breed and weight range.'
        )
      );
    }

    show(result);
    setAtc('ready', sizeKey);
  }

  function selectWeight(button, sizeKey, breedName) {
    Array.prototype.forEach.call(
      weightGrid.querySelectorAll('.tg4-weight-btn'),
      function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    );
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    if (weightField) weightField.value = button.textContent;
    renderResult(sizeKey, breedName);
  }

  function renderWeightRanges(breed) {
    var ranges = weightRangesFor(breed);
    weightGrid.innerHTML = '';
    clearResult();

    ranges.forEach(function (entry) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tg4-weight-btn';
      button.setAttribute('data-size', entry.size);
      button.setAttribute('aria-pressed', 'false');
      button.textContent = entry.range;

      button.addEventListener('click', function () {
        selectWeight(button, entry.size, breed.name);
      });

      weightGrid.appendChild(button);
    });

    show(step2);

    /* A single weight range leaves nothing to choose - pick it for the user. */
    if (ranges.length === 1) {
      selectWeight(weightGrid.firstChild, ranges[0].size, breed.name);
    } else {
      setAtc('no-weight');
    }
  }

  /* ------------------------------------------------------------ suggestions */

  function openSuggestions() {
    show(suggestions);
    breedInput.setAttribute('aria-expanded', 'true');
  }

  function closeSuggestions() {
    hide(suggestions);
    breedInput.setAttribute('aria-expanded', 'false');
    highlighted = -1;
  }

  function suggestionButtons() {
    return suggestions.querySelectorAll('.tg4-suggestion');
  }

  function setMessage(text) {
    suggestions.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'tg4-suggestions__hint';
    p.textContent = text;
    suggestions.appendChild(p);
    highlighted = -1;
  }

  function highlight(index) {
    var buttons = suggestionButtons();
    if (!buttons.length) return;

    highlighted = Math.max(0, Math.min(index, buttons.length - 1));
    Array.prototype.forEach.call(buttons, function (button, i) {
      button.classList.toggle('is-highlighted', i === highlighted);
    });
    buttons[highlighted].scrollIntoView({ block: 'nearest' });
  }

  function chooseBreed(breed) {
    selectedBreed = breed;
    breedInput.value = breed.name;
    if (breedField) breedField.value = breed.name;
    closeSuggestions();
    renderWeightRanges(breed);
  }

  function addGroupLabel(text) {
    var label = document.createElement('p');
    label.className = 'tg4-suggestions__group';
    label.textContent = text;
    suggestions.appendChild(label);
  }

  function addSuggestion(breed, query) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tg4-suggestion';
    button.setAttribute('role', 'option');

    /* Emphasise the portion the user actually typed. */
    var at = breed.name.toLowerCase().indexOf(query.toLowerCase());
    if (at === -1) {
      button.textContent = breed.name;
    } else {
      button.appendChild(document.createTextNode(breed.name.slice(0, at)));
      var mark = document.createElement('mark');
      mark.textContent = breed.name.slice(at, at + query.length);
      button.appendChild(mark);
      button.appendChild(document.createTextNode(breed.name.slice(at + query.length)));
    }

    button.addEventListener('click', function (event) {
      event.stopPropagation();
      chooseBreed(breed);
    });
    suggestions.appendChild(button);
  }

  /* Mutts and unlisted breeds size purely by weight, so offer that as an escape
     hatch rather than leaving a dead end. */
  function addMixedBreedNote() {
    var mixed = null;
    for (var i = 0; i < breeds.length; i++) {
      var name = breeds[i].name.toLowerCase();
      if (name === 'mixed breed' || name === 'mutt') {
        mixed = breeds[i];
        break;
      }
    }
    if (!mixed) return;

    var note = document.createElement('p');
    note.className = 'tg4-suggestions__note';
    var strong = document.createElement('strong');
    strong.textContent = "Don't see your dog's breed? ";
    note.appendChild(strong);
    note.appendChild(document.createTextNode('Mutts and mixed breeds size by weight range. '));

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'tg4-link';
    link.textContent = 'Select Mixed Breed';
    link.addEventListener('click', function (event) {
      event.stopPropagation();
      chooseBreed(mixed);
    });
    note.appendChild(link);
    note.appendChild(document.createTextNode(' to continue.'));
    suggestions.appendChild(note);
  }

  function renderSuggestions(query) {
    var needle = query.toLowerCase().trim();
    var starts = [];
    var contains = [];

    /* Names beginning with the query are the likely intent; the rest are still
       relevant but get demoted under their own heading. */
    breeds.forEach(function (breed) {
      var name = breed.name.toLowerCase().trim();
      if (name.indexOf(needle) === 0) starts.push(breed);
      else if (name.indexOf(needle) !== -1) contains.push(breed);
    });

    if (!starts.length && !contains.length) {
      setMessage('No matches found. Please try a different term.');
      addMixedBreedNote();
      return;
    }

    suggestions.innerHTML = '';

    starts.forEach(function (breed) {
      addSuggestion(breed, query);
    });

    if (contains.length) {
      addGroupLabel('You might also mean:');
      contains.forEach(function (breed) {
        addSuggestion(breed, query);
      });
    }

    addMixedBreedNote();
    highlight(0);
  }

  /* ----------------------------------------------------------------- events */

  breedInput.addEventListener('focus', function () {
    if (breedInput.value.trim().length >= MIN_QUERY_LENGTH) openSuggestions();
  });

  breedInput.addEventListener('input', function () {
    var value = breedInput.value;

    /* Any edit invalidates the previous recommendation. */
    if (selectedBreed && value !== selectedBreed.name) resetToStep1();

    if (value.trim().length < MIN_QUERY_LENGTH) {
      setMessage('Type at least ' + MIN_QUERY_LENGTH + ' characters to see suggestions');
      closeSuggestions();
      return;
    }

    openSuggestions();
    renderSuggestions(value);
  });

  /* Keyboard nav lives on the input, not on window, so it cannot interfere with
     the control section's own window-level key handlers. */
  breedInput.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSuggestions();
      return;
    }

    if (suggestions.hidden) return;
    var buttons = suggestionButtons();
    if (!buttons.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      highlight(highlighted + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      highlight(highlighted - 1);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (highlighted >= 0) buttons[highlighted].click();
    }
  });

  document.addEventListener('click', function (event) {
    if (suggestions.hidden) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.tg4-search-wrap')) return;
    closeSuggestions();
  });

  /* -------------------------------------------------- direct size selection */

  if (chartPanel) {
    Array.prototype.forEach.call(
      chartPanel.querySelectorAll('.tg4-chart-card'),
      function (card) {
        card.addEventListener('click', function () {
          Array.prototype.forEach.call(
            chartPanel.querySelectorAll('.tg4-chart-card'),
            function (other) {
              other.classList.remove('is-active');
              other.setAttribute('aria-pressed', 'false');
            }
          );
          card.classList.add('is-active');
          card.setAttribute('aria-pressed', 'true');

          var sizeKey = card.getAttribute('data-size');
          if (SIZES[sizeKey]) setAtc('ready', sizeKey);
        });
      }
    );

    /* The two panels are alternates - the design links each to the other. */
    Array.prototype.forEach.call(section.querySelectorAll('[data-tg4-panel]'), function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var wantsFinder = link.getAttribute('data-tg4-panel') === 'finder';
        if (finderPanel) finderPanel.hidden = !wantsFinder;
        chartPanel.hidden = wantsFinder;
      });
    });
  }

  /* ------------------------------------------------------- carousel refresh */

  /* The section ships hidden, so Flickity measures it at zero width and the
     gallery collapses when the A/B tool reveals it. Re-measure on first paint. */
  function refreshCarousels() {
    if (!window.Flickity) return;
    ['#tg4-main-slider', '#tg4-thumbnail-slider'].forEach(function (selector) {
      var el = $(selector);
      if (!el) return;
      var instance = window.Flickity.data(el);
      if (instance) instance.resize();
    });
  }

  if (window.ResizeObserver) {
    var measured = false;
    var observer = new ResizeObserver(function () {
      if (section.offsetHeight > 0) {
        if (!measured) {
          measured = true;
          refreshCarousels();
          /* Flickity may still be initialising on first reveal. */
          setTimeout(refreshCarousels, 300);
        }
      } else {
        measured = false;
      }
    });
    observer.observe(section);
  }

  window.addEventListener('load', refreshCarousels);

  /* ----------------------------------------------------------- scroll links */

  /* The control section binds the same page-wide CTAs and scrolls to itself. Two
     listeners fighting over one click is what makes the sections feel like they
     override each other, so this handler runs in the capture phase and stops
     propagation - but only while variant 4 is the visible one. */
  var SCROLL_TRIGGERS = [
    '.promotional-block .button-link',
    '.custom-announcement',
    '.custom-announcement a',
    '.flex-button'
  ].join(', ');

  function isVisible() {
    return !!section.offsetParent && getComputedStyle(section).display !== 'none';
  }

  function scrollTo(target, offset) {
    if (!target) return;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: 'smooth'
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isVisible()) return;
      if (!(event.target instanceof Element)) return;

      var badge = event.target.closest('.jdgm-preview-badge');
      if (badge && section.contains(badge)) {
        event.preventDefault();
        event.stopPropagation();
        scrollTo(document.querySelector('#judgeme_product_reviews'), -120);
        return;
      }

      if (!event.target.closest(SCROLL_TRIGGERS)) return;
      event.preventDefault();
      event.stopPropagation();
      scrollTo(section, 1);
    },
    true
  );

  /* ------------------------------------------------------------------- init */

  setAtc('no-breed');
})();
